module.exports = __webpack_public_path__ + "media/images/partner/pic_2@2x-a237381d9f36de6a4399bf2a5fdad8b7.png";